	Object.defineProperty(exports, "__esModule", {
	    value: true
	});exports.default=window.GrimoireJS;


//////////////////
// WEBPACK FOOTER
// ./~/grimoirejs/ref/index.js
// module id = 30
// module chunks = 0